import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates an order to get the available application languages.
 */
export class GetOrgLangsCommandBody implements CommandBody {}
